module.exports = __webpack_public_path__ + "static/media/digital-phone.0210af8a.svg";